var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { useCallback, useEffect, useReducer } from "react";
import styled, { css, keyframes } from "styled-components";
import { useToastDispatch, useToastPauser } from ".";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { EmphasisEnum } from "../../enums";
var borderRadius = "4px";
var innerBorderRadius = "3px";
var StyledToast = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n", "\n"], ["\n", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      font-family: inherit;\n      min-height: 50px;\n      width: 100%;\n      box-sizing: border-box;\n      background-color: ".concat(theme.bgContent(), ";\n      color: ").concat(theme.colorContent(), ";\n      position: relative;\n      padding: 1rem 1rem .75rem 1rem;\n      cursor: pointer;\n      border-radius: ").concat(borderRadius, ";\n      border: 1px solid ").concat(theme.borderContent(), ";\n\n      &:hover {\n        box-shadow: ").concat(theme.boxShadow, ";\n        transform: scale(1.02);\n      }\n    ");
});
var LeftEmphasis = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n", "\n"], ["\n", "\n"])), function (_a) {
    var theme = _a.theme, emphasis = _a.emphasis;
    return "\n    font-weight: bold;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: .3rem;\n    height: 100%;\n    background-color: ".concat(theme[emphasis](), ";\n    color: ").concat(theme["".concat(emphasis, "Inverse")](), ";\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top-left-radius: ").concat(innerBorderRadius, ";\n    border-bottom-left-radius: ").concat(innerBorderRadius, ";\n    box-sizing: border-box;\n  ");
});
var Banner = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 1.5rem;\n  display: flex;\n  padding: .375rem;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 1.5rem;\n  display: flex;\n  padding: .375rem;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n"])));
var Title = styled.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var emphasis = _a.emphasis, theme = _a.theme;
    return "\n      color: ".concat(theme[emphasis](), ";\n      font-size: 12px;\n      line-height: 12px;\n      margin: 0;\n      padding-left: .625rem;\n      max-width: calc(100% - 2rem);\n      text-overflow: hidden;\n      font-family: inherit;\n      text-transform: capitalize;\n  ");
});
var MessageContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-top: 6px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-top: 6px;\n"])));
var Message = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 10px;\n"], ["\n  font-size: 10px;\n"])));
var SubMessage = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 8px;\n  padding-top: 2px;\n"], ["\n  font-size: 8px;\n  padding-top: 2px;\n"])));
var CloseIcon = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return "\n      color: ".concat(isActive ? theme.colorContent() : theme.colorContent(.75), ";\n\n      & > svg > path:last-child{\n        stroke-width: ").concat(isActive ? "2" : "0", ";\n      }\n   ");
});
var TimeBarAnimation = keyframes(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  from {\n    width: calc(100% - .3rem);\n  }\n  to {\n    width: 0%;\n    border-bottom-left-radius: 0px;\n  }\n"], ["\n  from {\n    width: calc(100% - .3rem);\n  }\n  to {\n    width: 0%;\n    border-bottom-left-radius: 0px;\n  }\n"])));
var TimeBar = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isPaused = _a.isPaused, timeoutMs = _a.timeoutMs, theme = _a.theme, emphasis = _a.emphasis;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      position: absolute;\n      animation: ", " ", "ms linear;\n      animation-play-state: ", ";\n      bottom: 0;\n      right: 0;\n      background-color: ", ";\n      height: .25rem;\n      box-sizing: border-box;\n      border-bottom-right-radius: ", ";\n    "], ["\n      position: absolute;\n      animation: ", " ", "ms linear;\n      animation-play-state: ", ";\n      bottom: 0;\n      right: 0;\n      background-color: ", ";\n      height: .25rem;\n      box-sizing: border-box;\n      border-bottom-right-radius: ", ";\n    "])), TimeBarAnimation, timeoutMs, isPaused ? "paused" : "running", theme[emphasis](.3), innerBorderRadius);
});
var dispatchFn = function (state, action) {
    switch (action.type) {
        case "HANDLE_MOUSE_ENTER": {
            return __assign(__assign({}, state), { isActive: true });
        }
        case "HANDLE_MOUSE_LEAVE": {
            return __assign(__assign({}, state), { isActive: false });
        }
        case "HANDLE_PAUSE": {
            return __assign(__assign({}, state), { remaining: state.remaining - (new Date().getTime() - state.start), timer: null });
        }
        case "HANDLE_RESUME": {
            return __assign(__assign({}, state), { start: new Date().getTime(), timer: action.payload });
        }
        case "SET_TIMEOUT": {
            return __assign(__assign({}, state), { timer: action.payload });
        }
        default:
            return __assign({}, state);
    }
};
var EmphasisTitle = (_a = {},
    _a[EmphasisEnum.danger] = "Danger",
    _a[EmphasisEnum.primary] = "Info",
    _a[EmphasisEnum.secondary] = "Info",
    _a[EmphasisEnum.success] = "Success",
    _a[EmphasisEnum.tertiary] = "Info",
    _a[EmphasisEnum.warning] = "Warning",
    _a[EmphasisEnum.grey] = "Grey",
    _a);
var Toast = function (_a) {
    var id = _a.id, title = _a.title, message = _a.message, subMessage = _a.subMessage, timeoutMs = _a.timeoutMs, emphasis = _a.emphasis;
    var toastDispatch = useToastDispatch();
    var isPaused = useToastPauser();
    var _b = useReducer(dispatchFn, { start: new Date().getTime(), remaining: timeoutMs, isActive: false, timer: null }), _c = _b[0], isActive = _c.isActive, remaining = _c.remaining, timer = _c.timer, dispatch = _b[1];
    useEffect(function () {
        return function () {
            if (typeof timer === "number") {
                clearTimeout(timer);
                dispatch({
                    type: "SET_TIMEOUT",
                    payload: null
                });
            }
        };
    }, [timer]);
    useEffect(function () {
        if (!isPaused && timer === null) {
            var timeout = setTimeout(function () {
                toastDispatch({
                    type: "REMOVE_TOAST",
                    payload: id
                });
            }, remaining);
            dispatch({
                type: "HANDLE_RESUME",
                payload: timeout
            });
        }
        else if (isPaused && typeof timer === "number") {
            clearTimeout(timer);
            dispatch({
                type: "HANDLE_PAUSE",
            });
        }
    }, [isPaused, id, remaining, toastDispatch, timer]);
    var handleClick = useCallback(function () {
        toastDispatch([
            {
                type: "REMOVE_TOAST",
                payload: id
            },
            {
                type: "SET_TOAST_PAUSE",
                payload: false
            }
        ]);
    }, [toastDispatch, id]);
    var handleMouseOver = useCallback(function () {
        if (!isActive) {
            dispatch({
                type: "HANDLE_MOUSE_ENTER",
            });
            toastDispatch({
                type: "SET_TOAST_PAUSE",
                payload: true
            });
        }
    }, [isActive, toastDispatch]);
    var handleMouseLeave = useCallback(function () {
        toastDispatch({
            type: "SET_TOAST_PAUSE",
            payload: false
        });
        dispatch({
            type: "HANDLE_MOUSE_LEAVE",
        });
    }, [toastDispatch]);
    return (React.createElement(StyledToast, { onClick: handleClick, onMouseOver: handleMouseOver, onMouseLeave: handleMouseLeave },
        React.createElement(MessageContainer, null,
            React.createElement(Message, null, message),
            React.createElement(SubMessage, null, subMessage)),
        React.createElement(TimeBar, { isPaused: isPaused, timeoutMs: timeoutMs, emphasis: emphasis }),
        React.createElement(LeftEmphasis, { emphasis: emphasis }),
        React.createElement(Banner, null,
            React.createElement(Title, { emphasis: emphasis }, title ? title : EmphasisTitle[emphasis]),
            React.createElement(CloseIcon, { isActive: isActive },
                React.createElement(MdClose, { size: "10px" })))));
};
export default Toast;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
